<script>
	// NPM Modules
	import Papa from 'papaparse';
	// Stores
	import ReportOutputStore from '@/Stores/ReportOutputStore.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import Icon from '@/Components/Icon.svelte';
	// Services
	import { notify } from '@/Services/Notify';

	export let output;
	export let open = false;

	let url = undefined;
	let csvData = undefined;
	let fields = undefined;

	$: output && open && getCsv();
	$: url && prepareCsv();

	function getCsv() {
		return ReportOutputStore.getReportDownloadLink(output.id)
			.then((result) => {
				url = result.url;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Problem previewing the report.',
					timeout: 5
				});
			});
	}

	function prepareCsv() {
		Papa.parse(url, {
			download: true,
			header: true,
			complete: function (results) {
				fields = results.meta.fields;
				csvData = results.data;
			}
		});
	}

	function onClose() {
		url = undefined;
		csvData = undefined;
		fields = undefined;
		open = false;
	}
</script>

{#if open}
	<Modal on:close={onClose} className="w-full mx-2">
		<div slot="header" class="flex items-center justify-center space-x-4">
			<h2 class="text-xl font-bold text-center">
				Preview Report: {output && output.name}
			</h2>
			{#if url}
				<button
					on:click={() => window.open(url)}
					class="hover:text-gray-600 focus:outline-none"
					title="Download Report"
				>
					<Icon name="download-cloud" classes="block inline" />
				</button>
			{/if}
		</div>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			{#if fields && csvData}
				<div class="overflow-scroll" style="max-height:calc(100vh * 0.8)">
					<table class="w-full">
						<thead>
							<tr class="text-xs text-left text-gray-500 uppercase">
								{#each fields as field}
									<th class="sticky top-0 px-4 pt-5 pb-4 font-medium bg-white">
										{field}
									</th>
								{/each}
							</tr>
						</thead>
						<tbody class="bg-white">
							{#each csvData as row}
								<tr>
									{#each fields as field}
										<td class="p-1 border-t">{row[field] || ''}</td>
									{/each}
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
			{:else}
				<div class="w-full py-6 text-center">Fetching report...</div>
			{/if}
			<button class="mb-4 btn btn-muted" on:click={onClose}>Close</button>
		</div>
	</Modal>
{/if}

<style>
	tbody tr:nth-child(odd) {
		background-color: #f7f7f7;
	}
</style>
